import { render, staticRenderFns } from "./CandidateAcceptActivator.vue?vue&type=template&id=f438d002&lang=pug"
import script from "./CandidateAcceptActivator.vue?vue&type=script&lang=js"
export * from "./CandidateAcceptActivator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports